var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3415 13.1648C39.9505 12.5572 39.9516 11.5709 39.344 10.9619L29.4423 1.03744C28.8347 0.428426 27.8484 0.427297 27.2394 1.03492C26.6304 1.64254 26.6292 2.62881 27.2369 3.23782L36.0384 12.0596L27.2167 20.8611C26.6076 21.4687 26.6065 22.455 27.2141 23.064C27.8218 23.673 28.808 23.6741 29.417 23.0665L39.3415 13.1648ZM0.844888 13.5769L38.2395 13.6198L38.2431 10.5044L0.848457 10.4615L0.844888 13.5769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsArrowWhite);
export default __webpack_public_path__ + "static/media/contactUsArrowWhite.ba37ee004d5553c25e503c215e860a5a.svg";
export { ForwardRef as ReactComponent };